import { Component, Input } from '@angular/core';
import { TranslationService } from '@dch/ng-common';
import {
  MONTH_TRANSLATION_KEYS,
  transactionService,
} from '@dch/billing-business-logic';
import { IAggregatorMonth } from '../models/aggregator.model';

@Component({
  selector: 'my-bill-evolution-chart-legend',
  templateUrl: './evolution-chart-legend.component.html',
  standalone: false,
})
export class EvolutionChartLegendComponent {
  @Input() aggregatorMonth: IAggregatorMonth;

  constructor(private translationService: TranslationService) {}

  getMonthLabel(date: string): string {
    const monthString: string | undefined = date.split('/')[1];
    const monthNumber: number = monthString ? parseInt(monthString, 10) - 1 : 0;
    return this.translationService.getTranslatedValueFor(
      MONTH_TRANSLATION_KEYS[monthNumber]
    );
  }

  getDocumentTypeLabel(documentType: string): string {
    return transactionService.getDocumentTypeLabel(
      this.translationService.getTranslatedValueFor.bind(
        this.translationService
      ),
      documentType
    );
  }
}
